(() => {
  const MAX_FILES = 3, MAX_SOURCE_BYTES = 5 * 1024 * 1024, MAX_UPLOAD_BYTES = 1024 * 1024;
  async function preparePhoto(file) {
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || !file.size || file.size > MAX_SOURCE_BYTES) throw new Error('file');
    const bitmap = await createImageBitmap(file);
    try {
      if (!bitmap.width || !bitmap.height || bitmap.width * bitmap.height > 40000000) throw new Error('file');
      const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(bitmap.width * scale)); canvas.height = Math.max(1, Math.round(bitmap.height * scale));
      const context = canvas.getContext('2d');
      context.fillStyle = '#fff'; context.fillRect(0, 0, canvas.width, canvas.height); context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      for (const quality of [0.82, 0.65, 0.45]) {
        const result = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
        if (result && result.size <= MAX_UPLOAD_BYTES) return result;
      }
      throw new Error('file');
    } finally { bitmap.close(); }
  }
  function init(root) {
    if (root.dataset.bound) return;
    const form = root.closest('form'), input = root.querySelector('input[type=file]'), list = root.querySelector('[data-photo-list]');
    const status = root.querySelector('[data-photo-status]'), links = root.querySelector('[data-photo-links]'), submit = form?.querySelector('[data-fab-review-submit]');
    if (!form || !submit || !window.createImageBitmap) return;
    root.dataset.bound = 'true'; input.disabled = false;
    let photos = [], busy = false, prepared = false;
    const message = (text, error = false) => { status.textContent = text || ''; status.classList.toggle('is-error', error); };
    const setBusy = value => { busy = value; input.disabled = value || form.dataset.submitting === 'true'; submit.disabled = value || form.dataset.submitting === 'true'; root.setAttribute('aria-busy', String(value)); list.querySelectorAll('button').forEach(button => { button.disabled = value || form.dataset.submitting === 'true'; }); };
    const render = () => {
      list.replaceChildren();
      photos.forEach((photo, index) => {
        const item = document.createElement('li'), img = document.createElement('img'), remove = document.createElement('button');
        img.src = photo.preview; img.alt = root.dataset.previewLabel + ' ' + (index + 1); img.width = 88; img.height = 88;
        remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', root.dataset.removeLabel + ' ' + (index + 1));
        remove.addEventListener('click', () => { if (busy) return; URL.revokeObjectURL(photo.preview); photos.splice(index, 1); prepared = false; links.value = ''; message(''); render(); });
        item.append(img, remove); list.append(item);
      });
    };
    input.addEventListener('change', async () => {
      const selected = [...input.files]; input.value = ''; if (!selected.length || busy) return;
      if (photos.length + selected.length > MAX_FILES) { message(root.dataset.limitError, true); return; }
      setBusy(true); message(root.dataset.preparing);
      const additions = [];
      try {
        for (const file of selected) { const blob = await preparePhoto(file); additions.push({ blob, preview: URL.createObjectURL(blob), url: null }); }
        photos.push(...additions); prepared = false; links.value = ''; render(); message('');
      } catch { additions.forEach(photo => URL.revokeObjectURL(photo.preview)); message(root.dataset.fileError, true); }
      finally { setBusy(false); }
    });
    async function api(url, options = {}) {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: AbortSignal.timeout(30000), ...options });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'connection');
      return data;
    }
    form.fabReviewPhotos = {
      get busy() { return busy; },
      async upload() {
        if (busy) throw new Error('photos');
        if (!photos.length) return [];
        if (prepared) return photos.map(photo => photo.url);
        setBusy(true); message(root.dataset.uploading);
        try {
          const endpoint = new URL(root.dataset.endpoint, location.origin); endpoint.searchParams.set('product', root.dataset.product);
          const session = await api(endpoint.href);
          for (let i = 0; i < photos.length; i++) {
            const upload = new URL(endpoint); upload.searchParams.set('slot', String(i));
            const result = await api(upload.href, { method:'POST', headers:{'Content-Type':'image/jpeg','X-Fabrikone-Photo-Token':session.token}, body:photos[i].blob });
            const url = new URL(result.url);
            if (url.origin !== 'https://fabrikone-studyom.fabrikone-apps.workers.dev' || !url.pathname.startsWith('/review-photo/')) throw new Error('photos');
            photos[i].url = url.href;
          }
          prepared = true; message(''); return photos.map(photo => photo.url);
        } catch (error) { prepared = false; message(root.dataset.uploadError, true); throw error; }
        finally { setBusy(false); }
      }
    };
    form.addEventListener('reset', () => { photos.forEach(photo => URL.revokeObjectURL(photo.preview)); photos = []; prepared = false; links.value = ''; message(''); render(); });
  }
  const start = () => document.querySelectorAll('[data-fab-review-photos]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();

